const formatValue = function(value = '', unit = '', maximumFractionDigits = 2, maxPower) {
    if (value === '') {
        return '';
    }

    value = parseFloat(value);
    if (isNaN(value)) {
        value = 0;
    }

    WiseMetering.numberFormatter ??= new NumberFormatter(WiseMetering.currentLocale);

    if (unit === 's') {
        return WiseMetering.numberFormatter.seconds(value, unit, maximumFractionDigits);
    } else if (['€', 'R$', '£', 'Kz', '$'].includes(unit)) {
        return WiseMetering.numberFormatter.currency(value, unit, maximumFractionDigits, maxPower);
    } else if (['Wh', 'VArh', 'g', 'W', 'VAr', 'VA'].includes(unit)) {
        return WiseMetering.numberFormatter.factorization(value, unit, maximumFractionDigits, maxPower);
    }

    return WiseMetering.numberFormatter.simple(value, unit, maximumFractionDigits);
};

export default formatValue;
